export const config = {
  apiUrl:      import.meta.env.VITE_API_URL      ?? '/api',
  clientId:    import.meta.env.VITE_ENTRA_CLIENT_ID,
  tenantId:    import.meta.env.VITE_ENTRA_TENANT_ID,
  redirectUri: import.meta.env.VITE_REDIRECT_URI ?? window.location.origin,
  apiScope:    import.meta.env.VITE_API_SCOPE,
} as const
